class LanguageSelector extends HTMLElement {
    constructor(el) {
        super();

        if (!el) return;

        this.el = el;
        this.form = this.el.querySelector('.js-language-selector-form');
        this.formInput = this.el.querySelector('.js-language-selector-form-input');
        this.languageHyperlinks = [...this.el.querySelectorAll('.js-language-selector-lang-hyperlink')];

        this.languageHyperlinks.forEach(item => item.addEventListener('click', this.onLangHyperlinkClick.bind(this)));
    }

    onLangHyperlinkClick(event) {
        event.preventDefault();
        
        this.formInput.value = event.currentTarget.dataset.value;
        localStorage.selectedLanguage = event.currentTarget.dataset.value;
        if (this.form) this.form.submit();
    }
}

customElements.define('language-selector', LanguageSelector);

class RegionCheckerBar {
    /**
        * Class constructor *
        * @arg {object} - `element` check for the
        * region checker bar element.
    **/
    constructor (element) {
        if (!element) return;

        this.hostname = window.location.hostname;
        this.pathname = window.location.pathname;

        this.regionCheckerBar = element;
        this.regionCheckerBarToggle = element.querySelector('.js-toggle-region-check');

        this.storeDataElements = document.querySelectorAll('[data-js-country-selector-store-data]');
        this.regionCheckerLangSelect = element.querySelector('#LanguageSelectorRegChecker');

        this.getCountry();
        this.attachEventListeners();
    }

    attachEventListeners () {
        if (this.regionCheckerBarToggle) {
            this.regionCheckerBarToggle.addEventListener('click', () => {
                this.regionCheckerBar.classList.add('hidden');
                this.regionCheckerBar.setAttribute('aria-hidden', 'true');

                // eslint-disable-next-line no-undef
                localStorage.selectedLanguage = Shopify.locale;
            });
        }
    }

    getCountry () {
        if (this.differentLanguage()) {
            this.regionCheckerBar.classList.remove('hidden');
            this.regionCheckerBar.setAttribute('aria-hidden', 'false');
        }

        if (window.geoip2 && localStorage.getItem('country') === null) {
            window.geoip2.country(this.onSuccess.bind(this), this.onError.bind(this));
        }
    }

    onSuccess (obj) {
        window.localStorage.setItem('country', obj.country.iso_code);

        const userCountryISOCode = window.localStorage.getItem('country');

        this.storeDataElements.forEach(storeDataElement => {
            const storeDataParsed = JSON.parse(storeDataElement.dataset.jsCountrySelectorStoreData);
            const storeCountryISOCode = storeDataParsed.iso_code;
            const storeURL = new URL(storeDataParsed.link);

            if ((this.hostname === storeURL.hostname) && (userCountryISOCode !== storeCountryISOCode)) {
                this.regionCheckerBar.classList.remove('hidden');
                this.regionCheckerBar.setAttribute('aria-hidden', 'false');
            }
        });
    }

    onError () {
        this.storeDataElements.forEach(storeDataElement => {
            const storeDataParsed = JSON.parse(storeDataElement.dataset.jsCountrySelectorStoreData);
            const storeCountryISOCode = storeDataParsed.iso_code;
            const storeURL = new URL(storeDataParsed.link);

            if (this.hostname === storeURL.hostname) {
                window.localStorage.setItem('country', storeCountryISOCode);
            }
        });
    }

    differentLanguage() {
        // eslint-disable-next-line no-undef
        if((navigator.language.split('-')[0] !== Shopify.locale && !localStorage.selectedLanguage && this.regionCheckerLangSelect) || (localStorage.selectedLanguage && localStorage.selectedLanguage !== Shopify.locale && this.regionCheckerLangSelect)) {
            return true;
        }
    }  
}

class RegionCurrent {
    constructor(el) {
        this.toSetToCurrent = document.querySelector('.js-localization-set-current-region');

        if (!el && !this.toSetToCurrent) return;

        this.current = el;

        this.init();
    }

    init () {
        this.toSetToCurrent.src = this.current.src;
    }
}

export {
    LanguageSelector,
    RegionCheckerBar,
    RegionCurrent
}
